import HTTP from "@/_helpers/http";
import { PUBLIC_LOGIN__MUTATIONS } from '../mutation-types'
import { PUBLIC_LOGIN__API } from '@/_helpers/urls'
import { PUBLIC_LOGIN__ACTIONS } from '../action-types'

// State
const state = {
    info: null,
    termsAndConditionLink: null,
    countries: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [PUBLIC_LOGIN__MUTATIONS.LOGINPAGEINFO](state, data) {
        state.info = data;
    },
    [PUBLIC_LOGIN__MUTATIONS.TERMSANDCONDITIONLINK](state, data) {
        state.termsAndConditionLink = data;
    },
    [PUBLIC_LOGIN__MUTATIONS.COUNTRIES](state, data) {
        state.countries = data;
    },
};

// Actions
const actions = {
    async [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]({ commit, state }) {
        try {
            const url = `${PUBLIC_LOGIN__API.LOGINPAGEINFO}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);

            if (response.status === 200) {
                commit(PUBLIC_LOGIN__MUTATIONS.LOGINPAGEINFO, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [PUBLIC_LOGIN__ACTIONS.TERMSANDCONDITIONLINK]({ commit, state }) {
        try {
            const url = `${PUBLIC_LOGIN__API.TERMSANDCONDITIONLINK}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);

            if (response.status === 200) {
                commit(PUBLIC_LOGIN__MUTATIONS.TERMSANDCONDITIONLINK, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [PUBLIC_LOGIN__ACTIONS.COUNTRIES]({ commit, state }) {
        try {
            const url = `${PUBLIC_LOGIN__API.COUNTRIES}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);

            if (response.status === 200) {
                commit(PUBLIC_LOGIN__MUTATIONS.COUNTRIES, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
